import { Start, Stop } from 'smg/buttons';

if (document.body.id === 'buttons') {
    main();
}

function main() {
    document.querySelectorAll<HTMLButtonElement>('.btn.button-start').forEach($btn => {
        Start($btn);

        $btn.parentElement?.addEventListener('click', () => {
            if ($btn.disabled) {
                Stop($btn);
            } else {
                Start($btn);
            }
        });
    });
}